import React, { useEffect } from 'react'
import moment from 'moment'

import {
  Box,
  Grid,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Barcode } from 'src/components/Barcode'
import { FreightOrder } from 'src/api/models'
import useProfileContext from 'src/context/ProfileContext'

const useStyles = makeStyles(() => ({
  table: {
    maxWidth: '80%',
    margin: 'auto',
    marginTop: '1rem',
  },
  label: {
    maxWidth: '90%',
    margin: 'auto',
    border: '1px solid gray',
    borderRadius: '1rem',
    padding: '0.2rem',
  },
  leftColumnData: {
    borderLeft: '1px solid gray',
    borderRight: '1px solid gray',
    padding: '4px',
    fontSize: '.7rem',
  },
  rightColumnData: {
    borderRight: '1px solid gray',
    padding: '4px',
  },
  rowData: {
    borderTop: '1px solid gray',
    borderBottom: '1px solid gray',
  },
}))

const billableActivity = [
  'Ecomm Order Processing',
  'Freight Order Processing/B2B',
  'Rush Order Fee',
  'Pallet handling Out',
  'Case pick Out',
  'Unit Pick Out',
  'Pallet Pick',
  'Labeling Fee',
  'Pallet Supply',
  'Pallet Wrap',
  'Labor',
  'Shipping Material (use codes & qty)',
  'Shipping Charge',
  'Misc Charge',
]

const responsibleInfo = [
  'Picked by',
  'Processed by',
  'Freight Order Location',
  'Date',
  'Start Time',
  'End Time',
  'Total Units',
  'Units Handled',
  'Total Pre-Made Pallets (did not unit pick)',
  'Total Pallets Created (units were picked)',
  'Total Skus',
]

interface Props {
  order: FreightOrder
  short?: boolean
  onLoaded?: () => void
  onReadyToPrint?: () => void
}

export const OrderLabel = (props: Props) => {
  const { order, short = false, onLoaded, onReadyToPrint } = props
  const barcode = { barcode: order.guid, type: 'datamatrix', displayName: '' }
  const classes = useStyles()
  const profileContext = useProfileContext()

  useEffect(() => {
    onLoaded?.()
    onReadyToPrint?.()
  }, [onLoaded, onReadyToPrint])

  return (
    <div className="always-page-break">
      <Box px={5} pt={5}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          spacing={2}
          className={classes.label}
        >
          <Grid item xs={3}>
            <Barcode barcode={barcode} />
          </Grid>
          <Grid item container xs={9}>
            <Grid item xs={12}>
              <Typography variant="h1">Order #{order.number}</Typography>
              <Typography variant="h2">Client: {order.client?.name}</Typography>
              <Typography variant="h5">{order.guid}</Typography>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={9}>
                <Typography variant="caption">
                  Printed on {moment().format('lll')} by {profileContext.profile?.firstName}{' '}
                  {profileContext.profile?.lastName}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="h5">Status</Typography>
                <Typography variant="body1">{order.status}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item container spacing={2} xs={12}>
            <Grid item>
              <Typography variant="subtitle2">PO#</Typography>
              <Typography variant="caption">{order.po}</Typography>
            </Grid>
            {order?.customFields &&
              order.customFields.map((cf) => (
                <>
                  <Grid item>
                    <Typography variant="subtitle2">{cf.label}</Typography>
                    <Typography variant="caption">{cf.value}</Typography>
                  </Grid>
                </>
              ))}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Order Details</Typography>
            <Typography variant="caption">{order.details}</Typography>
          </Grid>
        </Grid>
        {!short && (
          <>
            <Table className={classes.table} size="small">
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '60%' }}>Billabe Activity</TableCell>
                  <TableCell align="center">Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {billableActivity.map((item) => (
                  <TableRow key={item} className={classes.rowData}>
                    <TableCell className={classes.leftColumnData}>{item}</TableCell>
                    <TableCell className={classes.rightColumnData}></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Table className={classes.table} size="small">
              <TableBody>
                {responsibleInfo.map((item) => (
                  <TableRow key={item} className={classes.rowData}>
                    <TableCell className={classes.leftColumnData} style={{ width: '40%' }}>
                      {item}
                    </TableCell>
                    <TableCell className={classes.rightColumnData}></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}
      </Box>
    </div>
  )
}
